import config from "../../../api/config";
import { setConfigData } from "../../../config/reducer";
import environment from "../../../environment/environment";
import { store } from "../../../redux/store";

export const getConfig = async () => {
  try {
    const response = await config.getConfig();
    if (response.result !== "success") return;
    store.dispatch(
      setConfigData({
        buyerType: response.content.buyer_types,
        heardAboutSources: response.content.heard_about_sources,
        purchaseTimeframes: response.content.purchase_timeframes,
        landBudget: response.content.land_budgets,
      }),
    );
  } catch (error) {
    if (environment.debug) console.error(error);
  }
};
